import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosAdmin } from '../../../utils/axiosUser';

export const initStateLeagueCreate = {
  leagueCreate: { data: null, loading: false, error: null },
};

export const leagueCreate = createAsyncThunk('user/leagueCreate', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosAdmin
    .post(`/league/create`, data)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerLeagueCreate = {
  [leagueCreate.pending]: (state) => {
    state.leagueCreate.loading = true;
  },
  [leagueCreate.fulfilled]: (state, action) => {
    state.leagueCreate.loading = false;
    state.leagueCreate.data = action.payload;
    state.leagueCreate.error = null;
  },
  [leagueCreate.rejected]: (state, action) => {
    state.leagueCreate.data = null;
    state.leagueCreate.loading = false;
    state.leagueCreate.error = action.payload;
  },
};
